import {
  GET_LIST_QUANLYTHUCHIHOPDONG,
  GET_LIST_QUANLYTHUCHIHOPDONG_SUCCESS,
  GET_LIST_QUANLYTHUCHIHOPDONG_FAILURE,
} from "../../actions/QuanLyThuChiHopDong/actionTypes";

const initialState = {
  List: [],
  TotalQuantity: 0,
  TotalTienThu: 0,
  TotalTienChi: 0,
  TotalPhiKho: 0,
  TotalPhiKhac: 0,
  TotalPhiHoaHong: 0,
  TotalPhiPhat: 0,
  IsHoaHongTraGop: "0",
  IsPhiKho: 1,
  TotalValueGoc: 0,
  TotalValueLai: 0,
  TotalOtheFeeHangKy: 0,
  TotalPhiPhatDongLai: 0,
  TotalPhiDongLaiCham: 0,
  TotalPhiPhatTatToan: 0,
  getListQuanLyThuChiHopDongLoading: false,
};
const getListQuanLyThuChiHopDong = (state, action) => ({
  ...state,
  getListQuanLyThuChiHopDongLoading: true,
});

const getListQuanLyThuChiHopDongSuccess = (state, action) => {
  // console.log(action);
  return {
    ...state,
    List: action.payload.List,
    TotalQuantity: action.payload.TotalQuantity,
    TotalTienThu: action.payload.TotalTienThu,
    TotalTienChi: action.payload.TotalTienChi,
    TotalPhiKho: action.payload.TotalPhiKho,
    TotalPhiKhac: action.payload.TotalPhiKhac,
    TotalPhiHoaHong: action.payload.TotalPhiHoaHong,
    TotalPhiPhat: action.payload.TotalPhiPhat,
    IsHoaHongTraGop: action.payload.IsHoaHongTraGop,
    IsPhiKho: action.payload.IsPhiKho,
    TotalValueGoc: action.payload.TotalValueGoc,
    TotalValueLai: action.payload.TotalValueLai,
    TotalOtheFeeHangKy: action.payload.TotalOtheFeeHangKy,
    TotalPhiPhatDongLai: action.payload.TotalPhiPhatDongLai,
    TotalPhiPhatTatToan: action.payload.TotalPhiPhatTatToan,
    TotalPhiDongLaiCham: action.payload.TotalPhiDongLaiCham,
    getListQuanLyThuChiHopDongLoading: false,
  };
};

const getListQuanLyThuChiHopDongFailed = (state, action) => ({
  ...state,
  getListQuanLyThuChiHopDongLoading: false,
  List: [],
});
export const listQuanLyThuChiHopDongReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GET_LIST_QUANLYTHUCHIHOPDONG:
      return getListQuanLyThuChiHopDong(state, action);
    case GET_LIST_QUANLYTHUCHIHOPDONG_SUCCESS:
      // alert("tuty");
      return getListQuanLyThuChiHopDongSuccess(state, action);
    case GET_LIST_QUANLYTHUCHIHOPDONG_FAILURE:
      //alert('false')
      return getListQuanLyThuChiHopDongFailed(state, action);
    default:
      return state;
  }
};

export default listQuanLyThuChiHopDongReducer;
